// extracted by mini-css-extract-plugin
export default {"cls1":"ui1_neLoo4UK50hFKryc","cls2":"G3LLcqAVfbEuEV7QfcUd ui1_neLoo4UK50hFKryc"};